var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 118,
    viewBox: "0 0 118 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_1798)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59 16.3241C60.2103 16.3241 61.1915 15.3429 61.1915 14.1326C61.1915 12.9223 60.2103 11.9411 59 11.9411C57.7897 11.9411 56.8085 12.9223 56.8085 14.1326C56.8085 15.3429 57.7897 16.3241 59 16.3241Z",
    fill: "#FFCD83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7997 59.0068L69.462 54.6713L77.9497 40.057L63.3354 48.5447L59.0068 32.2071L54.6713 48.5447L40.057 40.0502L48.5447 54.6645L32.2071 58.9932L48.5447 63.3286L40.0503 77.9429L54.6646 69.4553L58.9932 85.7997L63.3287 69.4553L77.943 77.9497L69.4553 63.3354L85.7997 59.0068Z",
    stroke: "#FFCD83",
    strokeWidth: 2.07,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.8253 69.0889L70.3169 58.9253L83.6896 48.5786L66.9517 50.9465L69.0889 34.1747L58.9254 47.683L48.5787 34.3171L50.9465 51.0483L34.1747 48.9111L47.6831 59.0746L34.3172 69.4213L51.0551 67.0602L48.9111 83.8253L59.0746 70.3169L69.4213 83.6896L67.0603 66.9517L83.8253 69.0889Z",
    stroke: "#FFCD83",
    strokeWidth: 2.07,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3124 59.9227C64.17 61.0286 63.6747 62.0938 62.8266 62.9419C60.764 65.0045 57.3852 64.9773 55.2888 62.8741C53.1855 60.7708 53.1584 57.3988 55.2209 55.3362C56.069 54.4881 57.1342 53.9996 58.2401 53.8504C58.1926 53.8911 58.1519 53.9318 58.1112 53.9725C56.4625 55.6212 56.4829 58.3215 58.1655 59.9973C59.8481 61.6732 62.5416 61.7003 64.1903 60.0516C64.231 60.0109 64.2717 59.9634 64.3124 59.9227Z",
    stroke: "#FFCD83",
    strokeWidth: 2.07,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2239 64.4685C62.2778 64.4685 64.7534 61.9928 64.7534 58.9389C64.7534 55.885 62.2778 53.4094 59.2239 53.4094C56.17 53.4094 53.6943 55.885 53.6943 58.9389C53.6943 61.9928 56.17 64.4685 59.2239 64.4685Z",
    stroke: "#FFCD83",
    strokeWidth: 2.07,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3464 5.3328C61.8835 6.25552 59.9227 8.20274 59 10.6656C58.0705 8.20274 56.1165 6.25552 53.6604 5.3328C56.1233 4.40329 58.0773 2.45607 59 0C59.9295 2.46286 61.8835 4.41007 64.3464 5.3328Z",
    fill: "#FFCD83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59 20.2388C59.7307 20.2388 60.323 19.6465 60.323 18.9158C60.323 18.1851 59.7307 17.5928 59 17.5928C58.2693 17.5928 57.677 18.1851 57.677 18.9158C57.677 19.6465 58.2693 20.2388 59 20.2388Z",
    fill: "#FFCD83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59 106.066C60.2103 106.066 61.1915 105.085 61.1915 103.874C61.1915 102.664 60.2103 101.683 59 101.683C57.7897 101.683 56.8085 102.664 56.8085 103.874C56.8085 105.085 57.7897 106.066 59 106.066Z",
    fill: "#FFCD83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6536 112.667C56.1165 111.744 58.0773 109.797 59 107.334C59.9295 109.797 61.8835 111.744 64.3396 112.667C61.8767 113.597 59.9227 115.544 59 118C58.0705 115.537 56.1165 113.59 53.6536 112.667Z",
    fill: "#FFCD83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59 100.407C59.7307 100.407 60.323 99.8149 60.323 99.0842C60.323 98.3535 59.7307 97.7612 59 97.7612C58.2693 97.7612 57.677 98.3535 57.677 99.0842C57.677 99.8149 58.2693 100.407 59 100.407Z",
    fill: "#FFCD83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.874 61.1915C105.085 61.1915 106.066 60.2103 106.066 59C106.066 57.7897 105.085 56.8085 103.874 56.8085C102.664 56.8085 101.683 57.7897 101.683 59C101.683 60.2103 102.664 61.1915 103.874 61.1915Z",
    fill: "#FFCD83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.667 64.3463C111.744 61.8835 109.797 59.9227 107.334 59C109.797 58.0705 111.744 56.1165 112.667 53.6604C113.597 56.1233 115.544 58.0773 118 59C115.537 59.9295 113.59 61.8835 112.667 64.3463Z",
    fill: "#FFCD83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.7612 59C97.7612 58.2672 98.3514 57.677 99.0842 57.677C99.8169 57.677 100.407 58.2672 100.407 59C100.407 59.7327 99.8169 60.323 99.0842 60.323C98.3514 60.323 97.7612 59.7327 97.7612 59Z",
    fill: "#FFCD83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1326 61.1915C15.3429 61.1915 16.3241 60.2103 16.3241 59C16.3241 57.7897 15.3429 56.8085 14.1326 56.8085C12.9223 56.8085 11.9411 57.7897 11.9411 59C11.9411 60.2103 12.9223 61.1915 14.1326 61.1915Z",
    fill: "#FFCD83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.3328 53.6536C6.25552 56.1165 8.20274 58.0773 10.6656 59C8.20274 59.9295 6.25552 61.8835 5.3328 64.3396C4.40329 61.8767 2.45607 59.9227 0 59C2.46286 58.0705 4.41007 56.1165 5.3328 53.6536Z",
    fill: "#FFCD83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2388 59C20.2388 59.7327 19.6486 60.323 18.9158 60.323C18.1831 60.323 17.5928 59.7327 17.5928 59C17.5928 58.2672 18.1831 57.677 18.9158 57.677C19.6486 57.677 20.2388 58.2672 20.2388 59Z",
    fill: "#FFCD83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3145 83.0654L12.9317 105.455",
    stroke: "#FFCD83",
    strokeWidth: 2.07,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.509 12.8774L83.0994 35.2874",
    stroke: "#FFCD83",
    strokeWidth: 2.07,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3213 35.2602L12.9385 12.8706",
    stroke: "#FFCD83",
    strokeWidth: 2.07,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.509 105.448L83.1061 83.0383",
    stroke: "#FFCD83",
    strokeWidth: 2.07,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_1798"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 118,
    height: 118,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTop);
export default __webpack_public_path__ + "static/media/top.5e389cc81e063a165c065182c137c690.svg";
export { ForwardRef as ReactComponent };